import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const ForgotPasswordOtpSend = createAsyncThunk("client/send-otp", async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${baseUrl}auth/api/v1/resend-otp`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Forgot password otp send  API Response:", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to forgot password otp send");
  }
});

export const SingUp_ForgotPasswordOtpVerify = createAsyncThunk(
  "client/verify-otp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}auth/api/v1/verify-email-otp`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("OTP verify API Response:", response);
      return response.data;
    } catch (error) {
      console.error("OTP verify error:", error);
      return rejectWithValue(error.response?.data?.message || "OTP verification failed");
    }
  }
);

export const verifyForgotPassword = createAsyncThunk(
  "client/verify-otp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}auth/api/v1/verify-forgot-otp`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("OTP verify API Response:", response);
      return response.data;
    } catch (error) {
      console.error("OTP verify error:", error);
      return rejectWithValue(error.response?.data?.message || "OTP verification failed");
    }
  }
);



// Get products
export const forgotPassWordUser = createAsyncThunk("auth/forgot-password", async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${baseUrl}auth/api/v1/forgot-password`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Forgot password otp send  API Response:", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to forgot password otp send");
  }
});

// submit new password
export const changeUserPassword = createAsyncThunk("auth/reset-password", async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${baseUrl}auth/api/v1/reset-password`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to forgot password submit new password");
  }
});